// extracted by mini-css-extract-plugin
export default {"container":"DemAb","content":"YzckX","properties":"l2GKF","doubleCol":"s0iTr"};